export default __webpack_public_path__ + "4bc6af5b5240cf6ac43e61551192a613.png";